var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3653_2393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.9602 15.5195C2.96018 15.5951 2.97562 15.67 3.00565 15.7398C3.03568 15.8096 3.07971 15.8731 3.13521 15.9265C3.19072 15.98 3.25661 16.0224 3.32914 16.0513C3.40166 16.0802 3.47939 16.0951 3.55789 16.0951H14.3164C14.3949 16.0951 14.4726 16.0802 14.5451 16.0513C14.6176 16.0224 14.6835 15.98 14.739 15.9265C14.7946 15.8731 14.8386 15.8096 14.8686 15.7398C14.8986 15.67 14.9141 15.5951 14.9141 15.5195V13.7928H2.9602V15.5195Z",
    fill: "url(#paint0_linear_3653_2393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4723 4.12648C16.3833 4.06136 16.2771 4.02149 16.1658 4.01136C16.0545 4.00123 15.9424 4.02124 15.8423 4.06915L11.6418 6.09146L9.49235 0.917085C9.44799 0.810237 9.3714 0.718642 9.27246 0.654121C9.17351 0.5896 9.05676 0.555115 8.93727 0.555115C8.81777 0.555115 8.70102 0.5896 8.60208 0.654121C8.50313 0.718642 8.42654 0.810237 8.38218 0.917085L6.23276 6.09146L2.03228 4.06915C1.93219 4.02094 1.82005 4.00077 1.70864 4.01092C1.59723 4.02106 1.49101 4.06113 1.40209 4.12656C1.31316 4.19198 1.2451 4.28013 1.20565 4.38098C1.16619 4.48183 1.15693 4.59131 1.17893 4.69698L2.829 12.6418H15.0455L16.6956 4.69698C16.7176 4.59129 16.7084 4.48178 16.6689 4.38092C16.6294 4.28005 16.5613 4.19189 16.4723 4.12648ZM8.93727 10.3396C8.58245 10.2973 8.25884 10.1232 8.0355 9.85436C7.81216 9.58552 7.70679 9.24328 7.74188 8.90067C7.70679 8.55805 7.81216 8.2158 8.03549 7.94697C8.25883 7.67814 8.58245 7.50402 8.93727 7.46178C9.29208 7.50401 9.61571 7.67813 9.83905 7.94696C10.0624 8.2158 10.1678 8.55805 10.1327 8.90067C10.1677 9.24328 10.0624 9.58553 9.83904 9.85436C9.6157 10.1232 9.29208 10.2973 8.93727 10.3396Z",
    fill: "url(#paint1_linear_3653_2393)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3653_2393",
    x1: 2.80021,
    y1: 14.9131,
    x2: 14.5406,
    y2: 14.9131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF846B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3653_2393",
    x1: 0.959283,
    y1: 6.43667,
    x2: 16.2218,
    y2: 6.43667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF846B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3653_2393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.65,
    height: 16.65,
    fill: "white",
    transform: "translate(0.612305)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.dc554b674fadff3785534df780e603cd.svg";
export { ForwardRef as ReactComponent };